import banner2 from "../assets/site.jpg";
import UnifiedServicePage from "./UnifiedServicePage";

export default function ElectricalSecurityInstallationsPage() {
  return (
    <UnifiedServicePage
      title="Electrical & Security Installations"
      kicker="Reliable Energy and Protection Systems"
      intro="We design, install, and maintain electrical, security, and backup power systems for residential, commercial, and industrial environments."
      heroImage={banner2}
      overviewTitle="Integrated Technical Delivery"
      overviewText="Our teams combine electrical engineering, safety compliance, and strong after-sales support to deliver dependable systems end-to-end."
      featureTitle="What We Deliver"
      features={[
        {
          title: "Electrical Installations",
          desc: "Professional residential, commercial, and industrial electrical installation and maintenance services.",
        },
        {
          title: "CCTV & Security Systems",
          desc: "End-to-end setup and support for CCTV, access control, and related security systems.",
        },
        {
          title: "Fire Safety Systems",
          desc: "Installation and servicing of fire detection and protection systems for critical facilities.",
        },
        {
          title: "Backup Power Solutions",
          desc: "Battery backup and hybrid power systems to improve uptime and operational continuity.",
        },
        {
          title: "Data & Communication",
          desc: "PBX, voice, and structured data installations for modern business operations.",
        },
        {
          title: "Maintenance Support",
          desc: "Preventive and corrective support plans that keep systems safe and efficient.",
        },
      ]}
      focusTitle="Project Delivery Highlights"
      focusItems={[
        {
          title: "Client Discovery",
          desc: "Requirements mapping and site review aligned with safety and performance goals.",
        },
        {
          title: "Engineering Design",
          desc: "Tailored system designs for resilient power and security operations.",
        },
        {
          title: "Installation",
          desc: "Standards-compliant implementation by experienced technical teams.",
        },
        {
          title: "After-Sales Service",
          desc: "Routine maintenance and responsive support for long-term reliability.",
        },
      ]}
      testimonyQuote="Working with DOUBLE F SMART ENERGIES ENTERPRISE on our electrical and security projects was a success from consultation through installation and support."
      testimonyAuthor="Spokesperson, BOA"
    />
  );
}
